'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissAgentTypingIndicator = undefined;

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _clearExistingAgentTypingTimeout = require('./clearExistingAgentTypingTimeout');

var _removeTypingTimeoutIdForAgentInThread = require('./removeTypingTimeoutIdForAgentInThread');

var dismissAgentTypingIndicator = exports.dismissAgentTypingIndicator = function dismissAgentTypingIndicator(message, threadId) {
  return function (dispatch) {
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _clearExistingAgentTypingTimeout.clearExistingAgentTypingTimeout)(message, threadId));

    dispatch((0, _removeTypingTimeoutIdForAgentInThread.removeTypingTimeoutIdForAgentInThread)(threadId, senderId));
  };
};